import ManagePermissions from "./ManagePermission";
import { OrganizationProfilePageWithModal } from "./OrganizationProfile";
import RolesPage from "./RolesAndPermissionPage";
import SettingLandingPage from "./SettingLandingPage";

const Setting = {
  OrganizationProfilePageWithModal,
  RolesPage,
  SettingLandingPage,
  ManagePermissions,
};
export default Setting;
